import { render, staticRenderFns } from "./MEntityChildUpdate.vue?vue&type=template&id=38d986ec&lang=pug&"
import script from "./MEntityChildUpdate.vue?vue&type=script&lang=js&"
export * from "./MEntityChildUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports